'use client';

import { PurifiedHtml } from 'components/purified-html';
import { espotContent } from 'services/marketing/types';

export const EspotContent = ({
  content,
  className,
  allowScript,
  skipSanitize
}: {
  content: espotContent;
  className?: string;
  allowScript?: boolean;
  skipSanitize?: boolean;
}) => {
  const { html } = content;

  if (skipSanitize) {
    return (<div className={className} dangerouslySetInnerHTML={{ __html: html }} />);
  }

  return (
    <PurifiedHtml
      htmlString={html}
      className={className}
      forceBody
      allowScript={allowScript}
    />
  );
};
